<template>
  <div>
    <v-card class="elevation-12">
      <v-card-title class="px-9 pt-7">
        Ostatní
      </v-card-title>

      <v-card-text class="px-9">

        <ValidationObserver
          ref="bulkOtherChangesForm"
          v-slot="{ invalid, passes }"
        >
          <v-form rel="bulkOtherChangesForm" @submit.prevent="passes(save)">
            <v-row>
              <v-col cols="4">
                <VFileInputWithValidation
                  v-model="file"
                  :rules="{
                    required: true,
                    ext: ['xlsx'],
                  }"
                  prepend-icon=""
                  append-icon="$file"
                  @click:append="
                    $event.target.offsetParent.querySelector(`[class='v-file-input__text']`).click()
                  "
                  :clearable="false"
                  outlined
                  dense
                  label="Nahrajte soubor .XLSX"
                  accept=".xlsx"
                  @change="fileUpload($event)"
                />
              </v-col>

              <v-col>
                <v-btn
                  depressed
                  type="submit"
                  height="40px"
                  min-width="125px"
                  color="primary"
                  :loading="loading"
                >
                  Odeslat
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>

        <v-row>
          <v-col class="mx-3" style="background-color: rgb(223, 237, 214);">
            <v-row>
              <v-col
                cols="12"
                class="d-inline-flex align-center justify-center px-1"
              >
                <h2>
                  Vzor
                </h2>
              </v-col>

              <v-col class="d-inline-flex align-center justify-center px-1">
                <a
                  href="ostatni-zmeny-vzor.xlsx"
                  @click.prevent="fileDownload($event)"
                >
                  Vzor .xlsx souboru pro odevzdání ostatních změn
                </a>
              </v-col>
            </v-row>
          </v-col>

          <v-col class="mx-3" style="background-color: rgb(223, 237, 214);">
            <v-row>
              <v-col
                cols="12"
                class="d-inline-flex align-center justify-center px-1"
              >
                <h2>
                  Nápověda
                </h2>
              </v-col>

              <v-col
                cols="12"
                class="d-inline-flex align-center justify-center px-1 text-center"
              >
                lorem ipsum
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <BulkInstallationDialog v-model="bulkInstallationDialogData" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BulkInstallationDialog from '@/components/dialogs/BulkInstallationDialog.vue';
import { downloadFile } from '@/components/mixins/downloadFile';
import { checkAuth } from '@/components/mixins/checkAuth';

export default {
  name: 'OtherChanges',
  components: {
    BulkInstallationDialog,
  },
  mixins: [downloadFile, checkAuth],
  data() {
    return {
      requestType: 'BULK_OTHER_CHANGE',
      file: null,
      bulkInstallationDialogData: {
        show: false,
        data: {},
      },
      loading: false,
      collectionPointLoading: false,
    };
  },
  methods: {
    ...mapActions({
      createNewBulkOtherRequest:
        'requests/createNewBulkOtherRequest',
    }),
    save() {
      this.loading = true;
      this.createNewBulkOtherRequest(this.file)
        .then((response) => {
          if (response.status === 200) {
            this.bulkInstallationDialogData.data = response.data;
            this.bulkInstallationDialogData.show = true;
          }
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.bulkInstallationDialogData.data = error.response.data;
            this.bulkInstallationDialogData.show = true;
          }
        })
        .finally(() => {
          this.loading = false;
          this.file = null;
          this.$refs.bulkOtherChangesForm.reset();
        });
    },
    fileUpload(event) {
      this.file = event;
    },
    fileDownload(event) {
      this.downloadFile(event, 'requests/BULK_OTHER_CHANGE_PARENT/template');
    },
  },
};
</script>
